import { TreeNode } from "./TreeNode";

export const getTestTree = (testList) => {
  // get all root test ids - tests not belong to 
  // other test's packagePackages and packageTests
  let rootTestIdList = [];
  for (let i = 0; i < testList.length; i++) {
    let currentGroupTest = testList[i];
    let remainingList = testList.slice(0, i+1).concat(testList.slice(i+1));
    // get all remaining groupTests' packagePackage and packageTest ids
    let idList = [];
    remainingList.forEach(test => {
      idList = idList
        .concat(test.packagePackages ? test.packagePackages : [])
        .concat(test.packageTests ? test.packageTests.map(t => t.id) : []);
    });
    if (!idList.includes(currentGroupTest.id)) {
      rootTestIdList.push(currentGroupTest.id);
    }
  }
  // build the tree
  let testNodeList = testList.map(t => new TreeNode(t)); // create tree node for all va tests
  let rootNodeList = testNodeList.filter(node => rootTestIdList.includes(node.id));
  rootNodeList.forEach(root => {
    buildTree(root, null, testNodeList);
  });

  return rootNodeList;
}


// create test tree structure for each node
function buildTree(currentNode, parentNode, testNodeList) {
  if (currentNode.parent)
    return;
  
  if (currentNode.value.type === "TEST")
    currentNode.parent = parentNode;
  else {
    let idList = (currentNode.value.packagePackages ? currentNode.value.packagePackages : [])
      .concat(currentNode.value.packageTests ? currentNode.value.packageTests.map(t => t.id) : []);
    let nodeList = testNodeList.filter(node => idList.includes(node.id));
    // recursively set parent for each node in nodeList
    nodeList.forEach(node => {
      buildTree(node, currentNode, testNodeList);
    });
    currentNode.parent = parentNode; // update current node's parent
    // update current node's descendants from nodeList 
    // after all nodes' parents in nodeList are set 
    currentNode.descendants = nodeList.filter(node => node.parent.id === currentNode.id);
  }
}